<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" class="bg-white">
    
            <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
                <br />
                <CRow class="mt-5">
                    <CButton type="button" class="btn custom-button-profile color-blue mb-5" @click="GoToCourse()"> + Add Bootcamp</CButton>
    
    
                </CRow>
                <CRow class="">
                    <CCol sm="12">
    
                        <h3 class="custom-32px text-left mt-2">Coming Soon</h3>
                        <CRow class="mb-2" v-for="(item,index) in boot" v-bind:key="item.Id">
                            <CRow>
                                <CCol sm="10"></CCol>
                                <CCol sm="2" class="float-right">
                                    <div class="text-right mt-3">
                                        <img style="width:50px" src="../assets/img/edit.jpeg" @click="GoToEdit(item.Id)"/>

                                        <img style="width:15px" src="../assets/img/trash.png" @click="OpenDelete(item.Id)"/>
                                    </div>
                                    </CCol>

                            <CCol sm="3" @click="GoToTraining(item.Id)"> <img v-if="item.FilePath != null" :src="getThumbnail(index)" style="max-width: 100%;border-radius:20px"/>
                                <img v-else src="../assets/img/C1.png" class="custom-bg-advetise" style="border-radius:20px" /></CCol>
                            <CCol sm="9" @click="GoToTraining(item.Id)">
                                <h3 class="custom-32px text-left">{{ item.Title }}</h3>
                                <CRow>
                                    <CCol sm="12"> <label class="custom-12px-500">
                                {{ item.Teacher }}
                                </label></CCol>
                                   
                                </CRow>
                              
                                <p class="custom-sub-text">
                                    <span v-html="truncateText(item.Synopsis)" style="max-width: 100%; font-size: 20px;"></span>
                                </p>
                                <CRow>
                                    <CCol sm="6">
                                        <span v-for="items in item.hash" v-bind:key="items.Id">
                                            <CButton class="custom-btn-light-blues color-blue-light mr-3">{{  items.Hashtag.substring(1) }} </CButton>
                                        </span>
                                       
                                    </CCol>
                                    <CCol sm="6">
                                        <div class="float-right">
                                            <CButton class="custom-btn-light-blues color-blue-light"><img style="width:24px" src="../assets/img/bookmarkblue.png" /> Design</CButton>
                                            <CButton class="custom-btn-light-blues ml-2 color-blue-light"><img style="width:24px" src="../assets/img/shareblue.png" /> Share</CButton>
                                        </div>
                                    </CCol>
                                </CRow>
                            </CCol>
                            </CRow>
                        </CRow>
                        <br />
                        <hr />
    
    
                    </CCol>
                </CRow>
                <CModal
          size="md"
          :show.sync="InactiveBootcampModal"
        >
          <div>
            <CCol sm="12">
              <CRow>
              
                <CCol sm="12" class="mt-3 text-black">
                    Are you sure you want to delete this bootcamp {{ bootcamp.Title }} ?
                </CCol>
              </CRow>
            </CCol>
          
            <br />
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              @click="DeleteBootcamp"
              color="info"
              >Proceed</CButton
            ></template
          >
        </CModal>
    
            </CCol>
    
        </CCol>
    </div>
</template>


<script>
import moment from "moment";
Vue.use(require("vue-moment"));

import Vue from "vue";
import AOS from "aos";
import "aos/dist/aos.css";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/AllHeader.vue";

export default {
    name: "App",
    components: {
        Mainlayout
    },
    created() {
        AOS.init();
    },
    data: () => ({

        boot: [],
        bootcamp: {},
        InactiveBootcampModal: false,
    }),
    async mounted() {
        let isAuth = await this.UserAuth();

        if (isAuth) {
            this.Busy = false;
            this.GetInfoUser();

            this.GetListBootcamp();
        } else {
            this.GoToLogin();
        }
    },
    //async mounted() {},
    methods: {
        GetInfoUser() {
            return this.$API
                .get(this.$LoginUserDetail, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.user = response.data;
                        this.GetAuthorizeProfile(this.user.id);
                    }
                });
        },
        GetAuthorizeProfile() {
            this.$API
                .get(this.$PickiddoUserProfile + "?userId=" + this.user.id, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.studentProfileAuthorize = response.data;
                        this.photoURL = this.studentProfileAuthorize.filePath;
                    }
                });
        },

        GetListBootcamp() {
            this.$API.get(this.$GetListBootcamp).then((response) => {
                if (response.status == 200 && response.data != null) {
                    this.boot = response.data;
                    this.getThumbnail(this.boot.FilePath);
                }
            });
        },
        getThumbnail(index) {
            return (
                "https://d3us0m7iuwh1d3.cloudfront.net/" + this.boot[index].FilePath
            );
        },

        logDuration(index) {
            durationVideos =
                "https://d3us0m7iuwh1d3.cloudfront.net/" +
                this.popular[index].fileVideo;
            //  this.durationVideo = this.$refs.durationVideos.duration;
            console.log("masuk", this.durationVideo);

            var x = this.$refs.durationVideos.duration;
            return x;
        },
        formatPrice(price) {
            // Check if price is a number or can be converted to a number
            if (!isNaN(parseFloat(price)) && isFinite(price)) {
                // Use toFixed(2) to format the number to two decimal places
                return parseFloat(price).toFixed(2);
            } else {
                // Handle cases where price is not a valid number
                return "N/A";
            }
        },
        GoToCourse() {
            this.$router.push("FormBootcamp")
        },
        truncateText(text) {
            const maxLength = 300;
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            }
            return text;
        },
        GoToTraining(id)
        {
            this.$router.push("BootcampById" + "?id=" + id)
        },
        GoToEdit(id)
        {
            this.$router.push("EditBootcamp" + "?id=" + id)
        },
        OpenDelete(id) {
            this.bootcampid = id;

      console.log("this." + id);

      this.$API
        .get(this.$GetListBootcampByIdFirst + "?Id=" + id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.bootcamp = response.data;
          }
        });

      
      this.InactiveBootcampModal = true;
    },

    DeleteBootcamp: function () {
      const formData = new FormData();
      formData.append("id", this.bootcampid);

      return this.$API
        .post(this.$DeleteBootcamp, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            if(response.data == 1)
            {
              this.InactiveBootcampModal = false;
            this.$dialog.alert("Success removed").then(function () {});

            }
            else
            {
                this.InactiveBootcampModal = false;
            this.$dialog.alert("Error").then(function () {});

            }
            
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to update ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>